class SpecimenSourceService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/medical/specimen-sources';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ specimenSource }) {
    const { data } = await this.axios.post(this.url, specimenSource);
    return data;
  }

  async update({ specimenSource }) {
    const { data } = await this.axios.put(this.url, specimenSource);
    return data;
  }

  async archive({ specimenSource }) {
    const { _id: id } = specimenSource;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: specimenSource });
    return data;
  }
}

export default SpecimenSourceService;
